import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse,
    HttpEventType
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError, finalize } from 'rxjs/operators';
import { HttpRequestService } from './http-request-service';
import { ProgressLoaderService } from './loader-service';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {

    private loaderCount: number = 0;
    constructor(private httpService: HttpRequestService, private progressLoader: ProgressLoaderService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.httpService.showLoader();
        this.progressLoader.showProgress();
        request = request.clone({
            url: (this.httpService.endpoint && !request.url.includes('assets/i18n') && !request.url.includes('assets/device-updates-filters'))
                ? (this.httpService.endpoint + request.url) : request.url
        });
        let httpEventResponse: HttpEvent<any>;
        let errorResponse: HttpErrorResponse;
        this.loaderCount++;
        return next.handle(request)
            .pipe(
                tap((response: HttpEvent<any>) => {

                    httpEventResponse = response;
                    if (response.type === HttpEventType.Response) {
                        this.checkLoader();
                    }
                }),
                catchError((error: HttpErrorResponse) => {
                    errorResponse = error;
                    this.checkLoader();
                    let apiError: any = error || {};
                    if (apiError.status != 200) {
                        apiError.error = apiError.error || {};
                        // Safe error message extraction
                        let errorMessage = 'No Response From Server';
                        if (Array.isArray(apiError.error)) {
                            errorMessage = apiError.error[0] || errorMessage;
                        } else if (apiError.error && typeof apiError.error === 'object') {
                            errorMessage = apiError.error.message || apiError.error.error || errorMessage;
                        } else if (typeof apiError.error === 'string') {
                            errorMessage = apiError.error;
                        }
                        this.httpService.errorToast(errorMessage);
                    }
                    this.httpService.getLoggedIn();
                    return throwError(apiError);
                }),
                finalize(() => {
                    this.progressLoader.hideProgress();
                    this.checkLoader();
                    if (httpEventResponse.type === HttpEventType.Sent && !errorResponse) {
                        this.httpService.errorToast('Time limit exceeded! or Request Canceled!');
                    }
                })
            );
    }

    checkLoader() {
        this.loaderCount--;
        if (this.loaderCount <= 0) {
            this.loaderCount = 0;
            this.httpService.hideLoader();
            this.progressLoader.hideProgress();
        }
    }
}